import { message } from 'antd';
import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import Loading from 'components/atoms/Loading';
import useNetwork from 'hooks/useNetwork';
import { getAccessToken } from 'services/common/storage';
import { useAppDispatch } from 'store/hooks';
import { ROUTE_PATHS } from 'utils/constants';

interface MainLayoutProps {
  children?: React.ReactNode;
}

const Portal: React.FC<MainLayoutProps> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);

  const networkStatus = useNetwork();
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  useEffect(() => {
    if (!networkStatus.online) {
      if (!isInitialLoad) {
        message.warning('Network error. Please check your connection.');
      }
      setIsInitialLoad(false);
    } else if (!isInitialLoad) {
      message.success('You are online.');
    }
  }, [networkStatus.online, isInitialLoad]);

  useEffect(() => {
    const token = getAccessToken();
    if (token && window.location.pathname === ROUTE_PATHS.LOGIN) {
      navigate('/');
    } else {
      setLoading(false);
    }
  }, [dispatch, navigate]);

  if (loading) return <Loading variant="fullscreen" />;

  return <Outlet />;
};

export default Portal;
